import { render, staticRenderFns } from "./ModelPagination.vue?vue&type=template&id=6bed3596&"
import script from "./ModelPagination.vue?vue&type=script&lang=ts&"
export * from "./ModelPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports